import { AccredibleChipComponentModule } from '@accredible-frontend-v2/new-components/chip';
import { AccrediblePaginationComponentModule } from '@accredible-frontend-v2/new-components/pagination';
import { TabsComponentModule } from '@accredible-frontend-v2/new-components/ui-common';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DirectoryRegion } from '@directory-of-directories/domain';
import { TranslocoModule } from '@jsverse/transloco';
import { DirectoryListNoResultsComponent } from '../directory-list-no-results/directory-list-no-results.component';
import { DirectoryListComponent } from '../directory-list/directory-list.component';
import { DirectoryToolbarComponent } from '../directory-toolbar/directory-toolbar.component';
import { DirectoryStoreService } from '../services/directory-store.service';
import { DirectoryToolbarStateService } from '../services/directory-toolbar-state.service';

@Component({
  standalone: true,
  selector: 'dod-main-content',
  templateUrl: `./main-content.component.html`,
  styleUrls: ['./main-content.component.scss'],
  imports: [
    CommonModule,
    TranslocoModule,
    TabsComponentModule,
    AccredibleChipComponentModule,
    AccrediblePaginationComponentModule,
    DirectoryToolbarComponent,
    DirectoryListComponent,
    DirectoryListNoResultsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainContentComponent {
  private readonly _store = inject(DirectoryStoreService);
  private readonly _state = inject(DirectoryToolbarStateService);

  toolbar = viewChild(DirectoryToolbarComponent);

  directories = this._store.directories;
  loading = this._store.loading;
  noResults = this._store.noResults;

  currentRegionMetadata = this._store.currentRegionMetadata;
  currentRegion = toSignal(this._state.currentRegion$, { initialValue: 'US' as DirectoryRegion });

  handleFiltersCleared(): void {
    this.toolbar().clearFilters();
  }

  onPageChange($event: number): void {
    this._state.updatePage($event);
  }

  onTabChange(region: DirectoryRegion): void {
    this._state.update({
      currentRegion: region,
    });
  }
}
